module.exports = __webpack_public_path__ + "img/no-positions.5b4cd308.svg";